export const visualIvrSteps = Object.freeze({
  MENU: 'MENU',
  CATEGORY_ACTIONS_PAGE: 'CATEGORY_ACTIONS_PAGE',
});
export const visualIvrColors = Object.freeze({
  BLACK: '#000000',
  WHITE: '#FFFFFF',
});
export const previousPageButtonText = 'חזרה';
